import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ApiServiceService } from '../api-service.service';

import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect, type MatSelectChange } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscriber, takeUntil } from 'rxjs';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { SharedValidators } from '../shared/validators/shared-validators';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    NgxMatSelectSearchModule,
    MatOption,
    MatError,
    MatIcon,
    MatTooltip,
    NgxPaginationModule,
    CommonPaginationComponent,
    CommonSearchComponent,
    CommonDropdownSearchComponent,
  ],
})
export class UserManagementComponent implements OnInit, OnDestroy {
  page = 1;
  size = 10;
  totalLength = 0;
  searchText = '';
  filterSelect = '';
  hierarchyLevel = '';
  groupName = '';
  groupId = '';
  listOfUsers = [];

  viewType = 'List';
  userId = '';

  submitButton = true;
  updateButton = false;
  newUserPermission: {
    pageName: string;
    view: boolean;
    create: boolean;
    delete: boolean;
    update: boolean;
  }[] = [];

  listOfRole: {
    userRole: string;
    roleType: string;
    hierarchyLevel: number;
    groupId: { _id: string; groupName: string };
    userPermission: {
      pageName: string;
      view: boolean;
      create: boolean;
      delete: boolean;
      update: boolean;
    }[];
  }[] = [];
  roleListLength = 0;
  public filteredListOfRoles: {
    userRole: string;
    roleType: string;
    hierarchyLevel: number;
    groupId: { _id: string; groupName: string };
    userPermission: {
      pageName: string;
      view: boolean;
      create: boolean;
      delete: boolean;
      update: boolean;
    }[];
  }[] = [];
  roleFilterList: {
    key: string;
    value: string;
  }[] = [];
  userRoleNameFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();

  userForm: FormGroup = this.formBuilder.group({});
  loggedId = '';
  profilePicture = '';
  userPermission: {
    pageName: string;
    view: boolean;
    create: boolean;
    delete: boolean;
    update: boolean;
  }[] = [];
  createdByName = '';

  userView = false;
  userCreate = false;
  userUpdate = false;
  userDelete = false;

  constructor(
    private formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setUserManagementForm();
    if (this.userView) {
      this.fetchUserList();
      this.getRolesList();
    }
  }

  checkPermission() {
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.hierarchyLevel = this.apiMicroservice.decryptData(
      sessionStorage.getItem('hierarchyLevel') || ''
    );
    this.groupName = this.apiMicroservice.decryptData(
      sessionStorage.getItem('groupName') || ''
    );
    this.groupId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('groupId') || ''
    );
    this.createdByName = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userFullName') || ''
    );
    this.profilePicture = '../../assets/profile.png';

    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'User Management' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'User Management' && element.view === true) {
          this.userView = true;
        }
        if (element.pageName === 'User Management' && element.create === true) {
          this.userCreate = true;
        }
        if (element.pageName === 'User Management' && element.update === true) {
          this.userUpdate = true;
        }
        if (element.pageName === 'User Management' && element.delete === true) {
          this.userDelete = true;
        }
      }
    );
  }

  setUserManagementForm() {
    this.userForm = this.formBuilder.group({
      firstName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      lastName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      userRole: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      roleType: new FormControl('', Validators.required),
      hierarchyLevel: new FormControl('', Validators.required),
      groupId: new FormControl(''),
      groupName: new FormControl(''),
      customerEmail: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.validEmail,
      ]),
      mobileNumber: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.mobileNumberValidation,
      ]),
      status: new FormControl(
        'Active',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      userRefId: new FormControl(this.loggedId),
      searchUser: new FormControl(this.searchText),
      customerName: new FormControl(
        this.createdByName,
        SharedValidators.requiredAndNoEmptySpaces
      ),
      addressState: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      country: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.nonNumericNoSpecialChars,
      ]),
      Image: '',
    });
    this.profilePicture = '../../assets/profile.png';
    this.userId = '';
  }

  fetchUserList() {
    this.spinner.show();
    this.apiMicroservice
      .getAllUser1(
        this.page,
        this.size,
        this.hierarchyLevel,
        this.groupName,
        this.searchText,
        this.filterSelect
      )
      .subscribe((res) => {
        this.spinner.hide();
        this.listOfUsers = res.userData;
        this.totalLength = res.totalItems;
        this.apiMicroservice.openSnackbar('Fetched Successfully');
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchUserList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchUserList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.searchText = event;
    this.userForm?.get('searchUser')?.setValue(event);
    this.fetchUserList();
  }

  userFormSwitch(id: string) {
    if (id) {
      this.fetchUserDetails(id);
    } else {
      this.viewType = 'Add';
      this.submitButton = true;
      this.updateButton = false;
      this.setUserManagementForm();
      this.getRolesList();
    }
  }

  filterSelected(event: string) {
    this.page = 1;
    this.filterSelect = event;
    this.fetchUserList();
  }

  getRolesList() {
    this.apiMicroservice
      .getRole(1, 1000, '', this.hierarchyLevel, this.groupId)
      .subscribe((res) => {
        this.listOfRole = res.data;
        this.filteredListOfRoles = this.listOfRole.slice();
        this.roleFilterList = this.listOfRole.map((item) => {
          return {
            key: item.userRole,
            value: item.userRole,
          };
        });
        this.roleListLength = this.listOfRole.length;
        this.userRoleNameFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe((search: string) => {
            if (!search) {
              this.filteredListOfRoles = [...this.listOfRole];
              return;
            }

            // Filter the list based on search value
            search = search.toLowerCase();
            this.filteredListOfRoles = this.listOfRole.filter((item) =>
              (item?.userRole ?? '').toLowerCase().includes(search)
            );
          });
      });
  }

  onRoleChange(event: MatSelectChange) {
    const selectedRole = this.filteredListOfRoles.find(
      (role) => role.userRole === event.value
    );
    this.userForm.controls['userRole'].setValue(selectedRole?.userRole);
    this.userForm.controls['roleType'].setValue(selectedRole?.roleType);
    this.userForm.controls['hierarchyLevel'].setValue(
      selectedRole?.hierarchyLevel
    );
    this.newUserPermission = selectedRole?.userPermission || [];
    if (
      selectedRole?.roleType === 'MN' ||
      selectedRole?.roleType === 'TL' ||
      selectedRole?.roleType === 'US' ||
      selectedRole?.roleType === 'EX'
    ) {
      this.userForm.controls['groupId'].setValue(selectedRole?.groupId._id);
      this.userForm.controls['groupId'].setValidators(Validators.required);
      this.userForm.controls['groupId'].updateValueAndValidity();
      this.userForm.controls['groupName'].setValue(
        selectedRole?.groupId.groupName
      );
      this.userForm.controls['groupName'].setValidators(Validators.required);
      this.userForm.controls['groupName'].updateValueAndValidity();
    } else if (
      selectedRole?.roleType === 'AD' ||
      selectedRole?.roleType === 'SA'
    ) {
      this.userForm.controls['groupId'].setValue(null);
      this.userForm.controls['groupId'].removeValidators(Validators.required);
      this.userForm.controls['groupId'].updateValueAndValidity();
      this.userForm.controls['groupName'].setValue('');
      this.userForm.controls['groupName'].removeValidators(Validators.required);
      this.userForm.controls['groupName'].updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  addUserDetails() {
    if (this.userForm.invalid) {
      SharedValidators.markAllAsTouched(this.userForm);
      return;
    } else {
      this.spinner.show();
      const payload = this.userForm.value;
      payload.userPermission = this.newUserPermission;
      payload.Image = this.profilePicture;
      payload.userRefId = this.loggedId;
      this.apiMicroservice.createUser(payload).subscribe({
        next: (res) => {
          if (res.status) {
            this.viewType = 'List';
            this.addNew();
            this.apiMicroservice.openSnackbar(res.message);
            this.spinner.hide();
          } else {
            this.apiMicroservice.openSnackbar(res.message);
            this.spinner.hide();
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.apiMicroservice.openSnackbar(ERROR.error.message);
          this.spinner.hide();
        },
      });
    }
  }

  delete(id: string) {
    if (confirm('Are you sure?')) {
      this.spinner.show();
      this.apiMicroservice.deleteUser(id).subscribe((res) => {
        this.apiMicroservice.openSnackbar(res.message);
        this.ngOnInit();
      });
    }
  }

  fetchUserDetails(id: string) {
    this.spinner.show();
    this.getRolesList();
    this.viewType = 'Add';
    this.userId = id;
    this.apiMicroservice.getSingleUser(id).subscribe((res) => {
      this.submitButton = false;
      this.updateButton = true;
      const data = res.data[0];
      if (res.status) {
        this.userForm = this.formBuilder.group({
          firstName: new FormControl(data.firstName, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          lastName: new FormControl(data.lastName, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          userRole: new FormControl(
            data.userRole,
            SharedValidators.requiredAndNoEmptySpaces
          ),
          roleType: new FormControl(data.roleType, Validators.required),
          hierarchyLevel: new FormControl(
            data.hierarchyLevel,
            Validators.required
          ),
          groupId: new FormControl(data.groupId),
          groupName: new FormControl(data.groupName),
          customerEmail: new FormControl(data.customerEmail, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.validEmail,
          ]),
          mobileNumber: new FormControl(data.mobileNumber, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.mobileNumberValidation,
          ]),
          customerName: new FormControl(
            data.customerName,
            SharedValidators.requiredAndNoEmptySpaces
          ),
          status: new FormControl(
            data.status,
            SharedValidators.requiredAndNoEmptySpaces
          ),
          addressState: new FormControl(data.addressState, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          country: new FormControl(data.country, [
            SharedValidators.requiredAndNoEmptySpaces,
            SharedValidators.nonNumericNoSpecialChars,
          ]),
          Image: data.Image ? data.Image : '../../assets/source_right.png',
          userRefId: data.userRefId,
          id: id,
        });
        this.profilePicture = data.Image
          ? data.Image
          : '../../assets/source_right.png';
        this.newUserPermission = data.userPermission;
      } else {
        console.error('Failed to fetch user data.');
      }
    });
    this.spinner.hide();
  }

  updateUserDetails() {
    if (this.userForm.invalid) {
      SharedValidators.markAllAsTouched(this.userForm);
      return;
    } else {
      this.spinner.show();
      const payload = this.userForm.value;
      payload.userPermission = this.newUserPermission;
      payload.Image = this.profilePicture;
      payload.userRefId = this.loggedId;

      this.apiMicroservice.updateUser(payload).subscribe({
        next: (res) => {
          if (res.status) {
            this.viewType = 'List';
            this.addNew();
            this.apiMicroservice.openSnackbar(res.message);
            this.spinner.hide();
          } else {
            this.apiMicroservice.openSnackbar(res.message);
            this.spinner.hide();
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.apiMicroservice.openSnackbar(ERROR.error.message);
          this.spinner.hide();
        },
      });
    }
  }

  addNew() {
    this.userForm.reset();
    this.updateButton = false;
    this.submitButton = true;
    this.ngOnInit();
  }

  onChange($event: Event) {
    $event.stopPropagation(); // Stops event from bubbling up
    $event.preventDefault(); // Prevents any default behavior

    const file = ($event.target as HTMLInputElement).files?.[0];

    if (!file) return;
    const fileName = file.name;
    if (file.size >= 2 * 1024 * 1024) {
      this.apiMicroservice.openSnackbar('Max upload size allowed is 2mb');
    } else {
      const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      if (
        ext.toLowerCase() === 'png' ||
        ext.toLowerCase() === 'jpg' ||
        ext.toLowerCase() === 'jpeg'
      ) {
        this.convertToBase64(file);
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<string>) => {
      this.readFile(file, subscriber);
    });
    observable.subscribe((d: string) => {
      this.profilePicture = d;
    });
  }

  readFile(file: File, subscriber: Subscriber<string | null>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      const result = fileReader.result;
      if (typeof result === 'string') {
        // Type guard
        subscriber.next(result);
      } else {
        subscriber.error(new Error('File could not be read as a string.'));
      }
      subscriber.complete();
    };

    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  navigateBackToList() {
    this.viewType = 'List';
    this.userId = '';
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
